var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEpSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3908 1H11.6076H11.6092L12.5096 3.652L13.112 3.931C13.4086 4.06884 13.6947 4.22622 13.9682 4.402L14.5248 4.759L17.39 4.174L19 6.826L17.0336 8.8915L17.0809 9.5275C17.1037 9.84163 17.1037 10.1569 17.0809 10.471L17.0336 11.107L18.9984 13.174L17.39 15.826L14.5248 15.2395L13.9682 15.598C13.6946 15.7737 13.4085 15.9311 13.112 16.069L12.5096 16.348L11.6108 19H8.3908L7.49356 16.3495L6.88962 16.069C6.59272 15.9308 6.30611 15.7734 6.0318 15.598L5.47359 15.2395L2.60999 15.826L1 13.174L2.96636 11.107L2.91905 10.471C2.8964 10.1574 2.8964 9.84263 2.91905 9.529L2.96636 8.893L1.00315 6.826L2.61156 4.174L5.47516 4.762L6.03338 4.402C6.30769 4.22657 6.5943 4.06921 6.8912 3.931L7.49514 3.6505L8.3908 1ZM10 6.66663C9.11596 6.66663 8.26812 7.01782 7.643 7.64294C7.01788 8.26806 6.66669 9.1159 6.66669 9.99996C6.66669 10.884 7.01788 11.7319 7.643 12.357C8.26812 12.9821 9.11596 13.3333 10 13.3333C10.8841 13.3333 11.7319 12.9821 12.357 12.357C12.9822 11.7319 13.3334 10.884 13.3334 9.99996C13.3334 9.1159 12.9822 8.26806 12.357 7.64294C11.7319 7.01782 10.8841 6.66663 10 6.66663Z",
    fill: "black",
    fillOpacity: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpSetting);
export default __webpack_public_path__ + "static/media/ep_setting.1cb28a0ed45bcc6ec69c07cb3bbadc68.svg";
export { ForwardRef as ReactComponent };